var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.667a6.667 6.667 0 100-13.333 6.667 6.667 0 000 13.333zm.158-9.235a1.25 1.25 0 00-1.39.817.75.75 0 01-1.416-.498 2.75 2.75 0 015.344.916c0 1.065-.788 1.76-1.334 2.124a5.442 5.442 0 01-1.142.574l-.024.009-.008.002-.003.001h-.001l-.23-.689.23.69a.75.75 0 01-.477-1.422h.001s.002.002.238.71l-.237-.711.008-.003a2.785 2.785 0 00.237-.096c.162-.072.372-.177.576-.313.455-.304.666-.608.666-.876v-.002a1.25 1.25 0 00-1.038-1.233zm-.45 2.523zm0 0l.45-2.523-.45 2.523zm2.988-1.288h-.75.75zM11.75 16.5a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: "#A3A3A9"
  })));
}

export default SvgTooltip;